import { useState, useCallback } from 'react';
import { exportTableToCsv, CsvExportOptions } from 'utils/tables';

export interface UseCsvExportReturn {
  isExporting: boolean;
  exportToCsv: (options: CsvExportOptions) => Promise<void>;
}

export function useCsvExport(): UseCsvExportReturn {
  const [isExporting, setIsExporting] = useState(false);

  const exportToCsv = useCallback(async (options: CsvExportOptions) => {
    setIsExporting(true);
    try {
      await exportTableToCsv(options);
    } catch (error) {
      console.error('Failed to export data:', error);
      throw error;
    } finally {
      setIsExporting(false);
    }
  }, []);

  return {
    isExporting,
    exportToCsv,
  };
}
